export const priceSimulationActionTypes = {
    STORE_PRICE_SIMULATION_PACKAGES: 'STORE_PRICE_SIMULATION_PACKAGES',
    STORE_PRICE_SIMULATION_PACKAGE_CONTEXTS: 'STORE_PRICE_SIMULATION_PACKAGE_CONTEXTS',
    SAVE_DRAFT_PROPOSALS: 'SAVE_DRAFT_PROPOSALS',
    INVALIDATE_PACKAGE_CONTEXTS: 'INVALIDATE_PACKAGE_CONTEXTS',
    STORE_REVIEWERS: 'STORE_REVIEWERS',
    SUBMIT_FOR_APPROVAL_SUCCESS: 'SUBMIT_FOR_APPROVAL_SUCCESS',
} as const;
